import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import MainPage from "src/components/Page/MainPage";
import { onSuccessClickFormBasicForm } from "src/helpers/onSuccess";
import { useAppDispatch } from "src/store";
import ContractSourceCreateForm from "./create";
import ContractSourceEditForm from "./edit";
import {
  getContractSourceDetails,
  getContractSources,
} from "src/store/contract-sources/saga";
import {
  ContractSourceDetailDto,
  ContractSourceDto,
} from "src/store/contract-sources/type";
const ContractSourcesPage = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [data, setData] = useState<ContractSourceDto[]>([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [selected, setSelected] = useState<ContractSourceDetailDto>();
  const columns = [
    {
      text: t("Contract.Source.Name"),
      dataField: "Name",
    },
  ];

  return (
    <React.Fragment>
      <MainPage
        title={t("Contract.Source.PageTitle")}
        metaTag={t("Contract.Source.MetaTag")}
        gridProps={{
          addTitle: t("Contract.Source.AddButton").toString(),
          listData: data,
          columns: columns,
          setDataList: setData,
          action: getContractSources,
          //    onCreateClick: () => setShowCreate(true),
          editButton: {
            onClick: (id, data) => {
              dispatch(
                getContractSourceDetails({
                  payload: {
                    onSuccess: (message, payload, response) => {
                      let currenctObject = payload;
                      currenctObject.Translates = response.Translates;
                      setSelected(currenctObject);
                      return setShowEdit(true);
                    },
                    onError: () => {},
                  },
                  id: id,
                })
              );
            },
          },
          // deleteButton: {
          //   text: (id, data: SectorDto) =>
          //     t("Contract.Source.DeleteQA", {
          //       name: data.Name,
          //     }),
          //   action: deleteSectorSaga,
          //   onClick: (id, data) => setShowEdit(data),
          // },
        }}
      />
      <ContractSourceCreateForm
        open={showCreate}
        onHide={() => setShowCreate(false)}
        onSuccessClick={(m) =>
          onSuccessClickFormBasicForm({
            dispatch: dispatch,
            message: m,
            action: getContractSources,
            setDataList: setData,
          })
        }
      />
      {selected && (
        <ContractSourceEditForm
          data={selected}
          open={showEdit}
          onHide={() => {
            setShowEdit(false);
            return setSelected(undefined);
          }}
          onSuccessClick={(m) =>
            onSuccessClickFormBasicForm({
              dispatch: dispatch,
              message: m,
              action: getContractSources,
              setDataList: setData,
            })
          }
        />
      )}
    </React.Fragment>
  );
};

export default ContractSourcesPage;
